import Legend from "./Legend/index.js";
import defaultDomain from "../util/defaultDomain.js"; // eslint-disable-next-line @typescript-eslint/no-explicit-any
import { jsx as _jsx } from "react/jsx-runtime";
/** Linear scales map from continuous inputs to continuous outputs. */
export default function Linear(_ref) {
  let {
    scale,
    domain: inputDomain,
    steps = 5,
    ...restProps
  } = _ref;
  const domain = inputDomain || defaultDomain({
    steps,
    scale
  });
  return /*#__PURE__*/_jsx(Legend, {
    scale: scale,
    domain: domain,
    ...restProps
  });
}